import {
  Fade,
  Grid,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import useFetchJob from "../../api/effects/queries/Job/useFetchJob";
import HeaderGeneral from "../../components/Header/HeaderGeneral";
import JobCard from "../../components/JobCard";
import { WarningModal } from "../../components/WarningModal";
import { JobDetailResponse } from "../../models/Job";
import ProfileState from "../../recoil/ProfileState";
import { getCookie } from "../../utils/cookies";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "100%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "20px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingTop: "1%",
  paddingLeft: "1%",
  whiteSpace: "pre-wrap",
}));

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
  whiteSpace: "pre-wrap",
}));

const RootGrid = styled(Grid)(({ theme }) => ({
  paddingTop: "3%",
  width: "80%",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

const DetailGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: "3%",
  width: "80%",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

const BaseGrid = styled(Grid)(({ theme }) => ({
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/BackgroundJob.svg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
  },
}));

export default function JobDetailPage() {
  const { JobID } = useParams();

  const { data: JobData } = useFetchJob(JobID!);

  const [jobDetailData, setJobDetailData] = useState<JobDetailResponse>();

  useEffect(() => {
    if (JobData !== undefined) {
      setJobDetailData(JobData);
    }
  }, [JobData]);

  const recoilValue = useRecoilValue(ProfileState);

  const [profileComplete, setProfileComplete] = useState(
    recoilValue?.Data === false ||
    recoilValue?.Pendidikan === false ||
    recoilValue?.Keluarga === false ||
    recoilValue?.Questionnaire === false ||
    recoilValue?.KontakDarurat === false ||
    recoilValue?.KontakReferensi === false
  );

  useEffect(() => {
    if (recoilValue !== undefined) {
      setProfileComplete(
        recoilValue?.Data === false ||
        recoilValue?.Pendidikan === false ||
        recoilValue?.Keluarga === false ||
        recoilValue?.Questionnaire === false ||
        recoilValue?.KontakDarurat === false ||
        recoilValue?.KontakReferensi === false
      );
    }
  }, [recoilValue]);

  const theme = useTheme();

  const [buttonWidth, setButonWidth] = useState<string>("30%");

  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (isSmall) {
      setButonWidth("30%");
    } else {
      setButonWidth("20%");
    }
  }, [isSmall]);

  const navigate = useNavigate();

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState(
    "Mohon Untuk Lengkapi Profil terlebih dahulu"
  );

  const token = getCookie("token");

  const applyButton = () => {
    if (token === null) {
      navigate("/Login", {
        replace: true,
        state: {
          from: `/Job/${JobID}`,
        },
      });
    } else {
      profileComplete
        ? setWarningModalState(true)
        : navigate(`/Job/Apply/${JobID}`);
    }
  };

  return (
    <>
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
          navigate(`/Profile`, { replace: true });
        }}
        text={warningModalText}
      />
      <BaseGrid container justifyContent="center">
        <Grid item xs={12}>
          <HeaderGeneral />
        </Grid>
        <Fade in={true}>
          <RootGrid container justifyContent="center">
            {jobDetailData === undefined || JobID === undefined ? (
              <span />
            ) : (
              <JobCard
                Job={{
                  JOB_ID: JobID,
                  JOB: jobDetailData.JOB,
                  DIVISI: jobDetailData.DIVISI,
                  TANGGAL_DIBUAT: jobDetailData.TANGGAL_DIBUAT,
                  LOKASI: jobDetailData.LOKASI,
                  STATUS_KARYAWAN: jobDetailData.STATUS_KARYAWAN,
                }}
                ButtonHandler={applyButton}
                ButtonWidth={buttonWidth}
                ButtonText="Apply"
                BigTitle
                Sizexs={12}
                Sizemd={12}
                Sizelg={12}
                Sizexl={12}
              />
            )}
          </RootGrid>
        </Fade>
        <Fade in={true}>
          <DetailGrid container justifyContent="center">
            <SquareGrid container>
              <DescGrid container>
                <TitleGrid item xs={12}>
                  <Typography variant="h5">Job Description</Typography>
                </TitleGrid>
                <DescGrid item xs={12}>
                  <Typography variant="body2">
                    {jobDetailData?.DESCRIPTION}
                  </Typography>
                </DescGrid>
              </DescGrid>
              <DescGrid container>
                <TitleGrid item xs={12}>
                  <Typography variant="h5">Requirements</Typography>
                </TitleGrid>
                <DescGrid item xs={12}>
                  <Typography variant="body2">
                    {jobDetailData?.REQUIREMENT}
                  </Typography>
                </DescGrid>
              </DescGrid>

              <DescGrid container>
                <TitleGrid item xs={12}>
                  <Typography variant="h5">Qualification</Typography>
                </TitleGrid>
                <DescGrid item xs={12}>
                  <Typography variant="body2">
                    {jobDetailData?.QUALIFICATION}
                  </Typography>
                </DescGrid>
              </DescGrid>
            </SquareGrid>
          </DetailGrid>
        </Fade>
      </BaseGrid>
    </>
  );
}
